import { css } from "styled-components";

import { styled } from "sharedUI/styles";

export const ModalLikeContainer = styled.div<{ isFinished?: boolean }>`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    background-color: ${p => p.theme.bgColorLight};

    display: flex;
    flex-direction: column;

    box-shadow: 0px 24px 32px rgba(0, 0, 0, 0.1);

    ${p =>
        !p.isFinished &&
        css`
            animation: popit 350ms ease-in-out normal;
            @keyframes popit {
                0% {
                    opacity: 0;
                    transform: translate(-50%, -50%);
                }
                50% {
                    opacity: 1;
                    transform: translate(-50%, -50%) scale(1.05);
                }
                100% {
                    transform: translate(-50%, -50%);
                }
            }
        `}
`;

export const ModalContainer = styled(ModalLikeContainer)<{ width?: number; height?: number | "auto" }>`
    width: ${p => p.width || 600}px;
    height: ${p => {
        if (p.height === "auto") {
            return "auto";
        }

        return p.height || 500;
    }};

    border-radius: 8px;
`;

export const HeaderContainer = styled.div`
    height: 72px;

    display: flex;
    align-items: center;

    padding: 0 100px 0 32px;

    font-style: normal;
    font-weight: 800;
    font-size: 18px;
    line-height: 24px;
    color: ${p => p.theme.fgColorDark};

    box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.12);
`;

export const AppIconHeaderContainer = styled.div`
    display: flex;
    align-items: left;
    font-size: 18px;
    line-height: 32px;
    min-height: 32px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    color: ${p => p.theme.fgColorDark};

    span {
        margin-left: 12px;
    }
    em {
        font-weight: bold;
        font-style: normal;
    }
`;

export const CloseButton = styled.div`
    position: absolute;
    right: 0;
    top: 0;
    width: 72px;
    height: 72px;

    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;

    color: ${p => p.theme.fgColorDark};
`;

export const ItemWrapper = styled.div`
    display: flex;

    padding: 20px 0;

    box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.12);
`;

export const BodyContainer = styled.div`
    padding: 0 32px;
    flex-grow: 1;
    overflow: auto;
`;

export const TextWrapper = styled.div`
    flex-grow: 1;
    flex-shrink: 1;

    font-weight: 500;
    font-size: 18px;
    line-height: 130%;

    color: ${p => p.theme.fgColorMedium};
`;

export const Tag = styled.div<{ isNew: boolean }>`
    height: 25px;
    border-radius: 100px;

    padding: 0 12px;
    margin-left: 12px;

    flex-grow: 0;
    flex-shrink: 0;

    background-color: ${p => (p.isNew ? p.theme.bgGreen : p.theme.blue)};
    color: ${p => p.theme.fgColorAccent};

    text-transform: uppercase;
    font-size: 12px;

    display: flex;
    justify-content: center;
    align-items: center;
`;

export const Title = styled.span`
    color: ${p => p.theme.fgColorDark};
`;

export const Body = styled.span``;

export const Link = styled.a`
    text-decoration: underline !important;
    color: ${p => p.theme.fgColorMedium} !important;

    :hover {
        color: ${p => p.theme.fgColorMedium} !important;
    }
`;

export const FooterWrapper = styled.div`
    padding: 32px;

    display: flex;
    justify-content: flex-end;
`;
